import React from 'react';

import http from 'api/http';
import { componentAPI, componentFamilyAPI } from 'api/requests';

import {Prompt, withRouter} from 'react-router-dom';
import { stopPropagation } from 'helpers';

/**
 * Components
 */
import Header from './Header';
import GeneralInformation from './GeneralInformation';
import NotesSection from './NotesSection';
import FilePicker from 'Components/FilePicker';
import ApplicationActions from 'Components/ApplicationActions';
import NotificationManager from 'dom-managers/notification';
import Modal from 'Components/Modal';
import Button, {buttonColor, buttonType} from 'Components/Button';
import ComponentList from './ComponentList'

@withRouter
export default class DetailsApplication extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: props.familyInfo.name,
      notes: props.familyInfo.notes,
      testReports: props.familyInfo.testReports || [],
      familyComponents: props.familyInfo.components ? [...props.familyInfo.components] : [],
      inputErrors: {},
      requestInProcess: false,
      isModalOpen: false,
      availableComponentsList: '',
    };

    this.componentsIdsToAdd = [];
    this.componentsIdsToDelete = [];

    this.fileIdsToDelete = [];

    this.someDataWasInputted = false;

    this.requiredFields = ['name'];
  }

  componentDidMount() {
    if (!this.props.requestInProcess && this.props.familyInfo.name && !this.state.availableComponentsList) {
      this.getAvailableComponentsList();
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.familyInfo.name && this.props.familyInfo.name) {
      this.setState(
        {
          name: this.props.familyInfo.name,
          notes: this.props.familyInfo.notes,
          testReports: this.props.familyInfo.testReports,
          familyComponents: [...this.props.familyInfo.components],
        },
        () => {
          this.someDataWasInputted = false;
        }
      );
    }
    if (
      (!this.props.requestInProcess && this.props.familyInfo.name && !this.state.availableComponentsList) ||
      (!prevProps.components.length && this.props.components.length)
    ) {
      this.getAvailableComponentsList();
    }
  }

  handleInputChange = field => (value, error) => {
    const { inputErrors } = this.state;
    this.someDataWasInputted = true;

    if (!error || error.ops) {
      let newInputErrors = inputErrors;
      delete newInputErrors[field];
      this.setState({ [field]: value, inputErrors: newInputErrors });
    }
  };

  handleFileSelect = files => {
    this.someDataWasInputted = true;
    this.setState(prevState => ({
      testReports: [...prevState.testReports, ...files],
    }));
  };

  handleRemoveFile = index => () => {
    const { testReports } = this.state;
    this.someDataWasInputted = true;

    if (testReports[index].created) {
      this.fileIdsToDelete.push(testReports[index].id);
    }

    testReports.splice(index, 1);

    this.setState({ testReports });
  };

  getAvailableComponentsList = () => {
    const { components } = this.props;
    const { selectedType } = this.state;

    http.get(componentAPI.listWithoutFamily).then(({ data: noFamilyList }) => {
      let availableComponentsList = components.filter(component => component.componentType.id === selectedType.id);

      availableComponentsList.forEach(component => {
        if (!noFamilyList.find(componentWithNoFamily => componentWithNoFamily.id === component.id))
          component.disabled = true;
      });

      this.setState({ availableComponentsList });
    });
  };

  getAvailableComponentsList = () => {
    const { components } = this.props;
    const { type } = this.props.familyInfo;
    const { familyComponents } = this.state;

    http.get(componentAPI.listWithoutFamily).then(({ data: noFamilyList }) => {
      let availableComponentsList = components.filter(component => {
        let componentAvailable = component.componentType.id === type.id;
        if (componentAvailable) {
          componentAvailable = !familyComponents.find(
            alreadyAddedComponent => alreadyAddedComponent.id === component.id
          );
        }
        return componentAvailable;
      });

      availableComponentsList.forEach(component => {
        if (!noFamilyList.find(componentWithNoFamily => componentWithNoFamily.id === component.id))
          component.disabled = true;
      });

      this.setState({ availableComponentsList });
    });
  };

  selectComponentForAdd = component => {
    let { availableComponentsList } = this.state;

    if (!component.disabled) {
      component.checked = !component.checked;

      this.setState({ availableComponentsList });
    }
  };

  togleAllComponentsForAdd = togleTo => event => {
    let { availableComponentsList } = this.state;

    stopPropagation(event);

    availableComponentsList.forEach(component => {
      if (!component.disabled) {
        component.checked = togleTo;
      }
      this.setState({ availableComponentsList });
    });
  };

  addComponents = () => {
    let { availableComponentsList, familyComponents } = this.state;

    this.someDataWasInputted = true;

    let componentsToAdd = availableComponentsList.filter(component => component.checked);

    availableComponentsList = availableComponentsList.filter(component => !component.checked);

    componentsToAdd.forEach(component => {
      component.checked = false;
      component.newlyAdded = true;
      const deletionListIndex = this.componentsIdsToDelete.indexOf(component.id);
      if (deletionListIndex !== -1) {
        this.componentsIdsToDelete.splice(deletionListIndex, 1);
      } else {
        this.componentsIdsToAdd.push(component.id);
      }
    });
    familyComponents.push(...componentsToAdd);

    this.setState({ availableComponentsList, familyComponents });
  };

  selectComponentForDeletion = component => event => {
    let { familyComponents } = this.state;

    stopPropagation(event);

    component.checked = !component.checked;

    this.setState({ familyComponents });
  };

  deleteComponents = () => {
    let { availableComponentsList, familyComponents } = this.state;

    this.modalHeader = 'Confirmation';
    this.modalBody = 'Are you sure you want to remove selected components from component family?';
    this.modalConfirmAction = () => {
      this.someDataWasInputted = true;
      let componentsToDelete = familyComponents.filter(component => component.checked);

      familyComponents = familyComponents.filter(component => !component.checked);

      componentsToDelete.forEach(component => {
        component.checked = false;
        delete component.newlyAdded;
        const additionListIndex = this.componentsIdsToAdd.indexOf(component.id);
        if (additionListIndex !== -1) {
          this.componentsIdsToAdd.splice(additionListIndex, 1);
        } else {
          this.componentsIdsToDelete.push(component.id);
        }
      });
      availableComponentsList.push(...componentsToDelete);

      this.setState({ familyComponents, availableComponentsList }, this.closeModal);
    };
    this.openModal();
  };

  deleteAllComponents = () => {
    let { availableComponentsList, familyComponents } = this.state;
    if (familyComponents.length) {
      this.modalHeader = 'Confirmation';
      this.modalBody = 'Are you sure you want to remove selected components from component family?';
      this.modalConfirmAction = () => {
        this.someDataWasInputted = true;

        familyComponents.forEach(component => {
          component.checked = false;
          delete component.newlyAdded;
          const additionListIndex = this.componentsIdsToAdd.indexOf(component.id);
          if (additionListIndex !== -1) {
            this.componentsIdsToAdd.splice(additionListIndex, 1);
          } else {
            this.componentsIdsToDelete.push(component.id);
          }
        });
        availableComponentsList.push(...familyComponents);

        this.setState({ familyComponents: [], availableComponentsList }, this.closeModal);
      };
      this.openModal();
    }
  };

  deleteSingleComponent = component => {
    let { availableComponentsList, familyComponents } = this.state;
    this.someDataWasInputted = true;

    const componentIndex = familyComponents.indexOf(component);

    familyComponents.splice(componentIndex, 1);

    component.checked = false;
    delete component.newlyAdded;
    const additionListIndex = this.componentsIdsToAdd.indexOf(component.id);
    if (additionListIndex !== -1) {
      this.componentsIdsToAdd.splice(additionListIndex, 1);
    } else {
      this.componentsIdsToDelete.push(component.id);
    }

    availableComponentsList.push(component);

    this.setState({ familyComponents, availableComponentsList });
  };

  _handleBackClick = () => {
    const { user } = this.props;

    user.goBack();
  };

  validateForm = () => {
    const { user } = this.props;
    const { inputErrors } = this.state;
    let newInputErrors = inputErrors;

    const isEmptyArray = object => {
      return object.length !== undefined && typeof object === 'object' && !object.length;
    };

    const isEmptyString = object => {
      return !object.length && typeof object === 'string' && !object.length;
    };

    const isEmptyObject = object => {
      return object.length === undefined && typeof object === 'object' && !Object.keys(object).length;
    };

    this.requiredFields.forEach(fieldName => {
      if (
        isEmptyString(this.state[fieldName]) ||
        isEmptyArray(this.state[fieldName]) ||
        isEmptyObject(this.state[fieldName])
      )
        newInputErrors[fieldName] = true;
    });

    return new Promise((resolve, reject) => {
      this.setState({ inputErrors: newInputErrors }, () => {
        if (Object.keys(this.state.inputErrors).length) {
          NotificationManager.error(
            'note',
            'Cannot submit the application.',
            'Please check you information and try again.'
          );
          reject();
        } else if (isEmptyArray(this.state.testReports) && !user.isInternal()) {
          NotificationManager.error(
            'note',
            'Cannot submit the application.',
            'At least one file needs to be uploaded.'
          );
          reject();
        } else {
          resolve();
        }
      });
    });
  };

  updateFamily = () => {
    const { user, familyInfo, updateFamiliesListEntry } = this.props;
    const { name, notes, testReports } = this.state;

    if (this.someDataWasInputted) {
      this.validateForm().then(() => {
        const headers = {
          'Content-Type': 'multipart/form-data',
        };

        const requestJSON = {
          name,
          fileIdsToDelete: this.fileIdsToDelete,
          notes,
          componentsToAdd: this.componentsIdsToAdd,
          componentsToDelete: this.componentsIdsToDelete,
        };

        const dataPayload = new FormData();
        dataPayload.append('requestJson', JSON.stringify(requestJSON));
        testReports.forEach(file => {
          if (!file.created) dataPayload.append('reports', file);
        });

        this.modalBody = 'Are you sure you want to save this Component Family?';
        this.modalConfirmAction = () => {
          this.setState({ requestInProcess: true }, () => {
            http
              .post(componentFamilyAPI.info(familyInfo.id), dataPayload, { headers })
              .then(({ data }) => {
                NotificationManager.success(1, 'Changes successfully submitted');
                this.someDataWasInputted = false;
                updateFamiliesListEntry(data);
                this.closeModal();
                user.goToFamilyDetails(familyInfo.id);
              })
              .catch(error => {
                this.setState({ requestInProcess: false }, this.closeModal);
              });
          });
        };

        this.openModal();
      });
    } else {
      user.goToFamilyDetails(familyInfo.id);
    }
  };

  openModal = () => {
    this.setState({ isModalOpen: true });
  };

  closeModal = (cb = () => {}) => {
    this.setState({ isModalOpen: false, requestInProcess: false }, () => {
      if (typeof cb === 'function') cb();
    });
  };

  blockUnconfirmedTransition = location => {
    const { user } = this.props;

    if (this.someDataWasInputted) {
      this.modalHeader = 'Confirmation';
      this.modalBody = 'Are you sure you want to cancel changes that you made to this Component Family?';
      this.modalConfirmAction = () => {
        this.someDataWasInputted = false;
        this.closeModal(() => {
          user.goTo(location);
        });
      };
      this.openModal();
      return false;
    }
    return true;
  };

  render() {
    const {
      user,
      match,
      requestInProcess: familyDataRequestInProcess,
      categories,
      componentsRequestInProcess,
    } = this.props;
    const { type, status } = this.props.familyInfo;
    const {
      name,
      notes,
      testReports,
      familyComponents,
      inputErrors,
      isModalOpen,
      requestInProcess,
      availableComponentsList,
    } = this.state;
    const { familyId } = match.params;

    if (familyDataRequestInProcess) {
      return (
        <section className='scene__scene-wrapper'>
          <section className='scene__content-wrapper detailsScene__content-wrapper'>
            <Header user={user} familyId={familyId} loadInProgress={true} />
            <div className='ect-spinner _width_pc_100 _height_120'>
              <div className='ect-spinner__image' />
            </div>
          </section>
        </section>
      );
    } else {
      return (
        <section className='scene__scene-wrapper'>
          <section className={`scene__content-wrapper detailsScene__content-wrapper ${status.toLowerCase()}`}>
            <Header status={status} familyId={familyId} user={user} type={type} />
            <GeneralInformation
              type={type}
              category={categories.find(cat => cat.id === type.categoryId)}
              name={name}
              inputErrors={inputErrors}
              handleInputChange={this.handleInputChange}
            />
            <ComponentList
              familyComponents={familyComponents}
              user={user}
              components={availableComponentsList || []}
              selectComponentForAdd={this.selectComponentForAdd}
              togleAllComponentsForAdd={this.togleAllComponentsForAdd}
              addComponents={this.addComponents}
              selectComponentForDeletion={this.selectComponentForDeletion}
              deleteComponents={this.deleteComponents}
              deleteAllComponents={this.deleteAllComponents}
              componentsRequestInProcess={componentsRequestInProcess}
              deleteSingleComponent={this.deleteSingleComponent}
            />
            <NotesSection notes={notes} handleInputChange={this.handleInputChange} disabled={!user.isInternal()} />
            <section className='scene_section'>
              <FilePicker
                files={testReports}
                editableStateSectionHeader={`Upload Test Report ${user.isInternal() ? '' : '*'}`}
                sectionHeaderClassName='scene_section-header'
                doNotRemoveFiles={!user.isInternal()}
                handleRemoveFile={this.handleRemoveFile}
                handleFileSelect={this.handleFileSelect}
                httpParams={{
                  currentId: familyId,
                  fileIdFieldName: 'id',
                  currentMethod: componentFamilyAPI.downloadReport,
                }}
              />
            </section>
            <ApplicationActions
              cancelButtonLabel='Cancel'
              saveButtonLabel='Save'
              saveButtonAction={this.updateFamily}
              cancelButtonAction={this._handleBackClick}
            />
          </section>
          <Modal isOpen={isModalOpen}>
            {this.modalHeader && <header className='ect-modal-header'>{this.modalHeader}</header>}
            <div className='ect-modal-body'>
              {typeof this.modalBody === 'function' ? this.modalBody() : this.modalBody}
            </div>
            <footer className='ect-modal-footer'>
              <Button
                label='No'
                type={buttonType.secondary}
                color={buttonColor.gray}
                buttonClassName='_height_40 _width_160'
                onClick={this.closeModal}
              />
              <Button
                label='Yes'
                disabledWithSpinner={requestInProcess}
                buttonClassName='_height_40 _width_160'
                onClick={this.modalConfirmAction}
              />
            </footer>
          </Modal>
          <Prompt message={this.blockUnconfirmedTransition} />
        </section>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/ComponentFamily/Edit/index.jsx